import { render, staticRenderFns } from "./ConfiscateBook.vue?vue&type=template&id=1e0415be"
import script from "./ConfiscateBook.vue?vue&type=script&lang=js"
export * from "./ConfiscateBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports